import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpHandler, HttpRequest, HttpErrorResponse } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';

import { ConnectionService } from '@app/services/connection.service';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  constructor(private connectionService: ConnectionService) {}

  intercept(req: HttpRequest<any>, next: HttpHandler) {
    return next.handle(req).catch((err: any) => {
      console.log('http error: ' + err.status);
      if (err instanceof HttpErrorResponse) {
        if (err.status === 0) {
          this.connectionService.connectionLost.emit(this.connectionService.CONNECTION_LOST);
          return Observable.empty();
        }
        if (err.status === 500) {
          this.connectionService.connectionLost.emit(this.connectionService.SERVER_ERROR);
          return Observable.empty();
        }
      }
      //Other case throw an error
      return Observable.throw(err);
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/http-interceptors/error-interceptor.ts